import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface IBeamIconProps {
  size?: number;
  color?: string;
}

const IBeamIcon: React.FC<IBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-ibeam">
    {<path d="M6.886 2.898h10.228c0.065 0 0.117 0.052 0.117 0.117v0 0.675c0 0.065-0.052 0.117-0.117 0.117v0h-3.851c-0.466 0-0.843 0.378-0.843 0.843v14.575c0 0.525 0.426 0.951 0.951 0.951h3.743c0.065 0 0.117 0.052 0.117 0.117v0 0.69c0 0.065-0.052 0.117-0.117 0.117v0h-10.228c-0.065 0-0.117-0.052-0.117-0.117v0-0.68c0-0.065 0.052-0.117 0.117-0.117v0h3.725c0.49 0 0.892-0.401 0.892-0.892v-14.648c0-0.454-0.368-0.822-0.822-0.822h-3.795c-0.065 0-0.117-0.052-0.117-0.117v0-0.694c0-0.065 0.052-0.117 0.117-0.117v0z"></path>
    }  </SvgIcon>
);

export default IBeamIcon;
